import { useState } from "react";
import "./About_Mobile.css";
import logoLarge from "../resources/images/logo_large.png";
import { Link } from "react-router-dom";
import { about, alerts } from "../Data/siteContent";
import { NEWSLETTER_API_URL } from "../Data/apiEndpoints";
import MessageModal from "../components/shared/MessageModal";

const About_Mobile = () => {
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState({ isVisible: false, type: "error", title: "", message: "" });
  const isValidEmail = email => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleEmailChange = e => {
    setEmail(e.target.value);
  };

  const handleSubscribe = async () => {
    if (!isValidEmail(email)) {
      setFeedback({ isVisible: true, type: "error", title: "Invalid Email", message: alerts.invalidEmail });
      return;
    }

    try {
      const response = await fetch(NEWSLETTER_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setFeedback({ isVisible: true, type: "success", title: "Subscribed", message: alerts.subscribeSuccess });
        setEmail("");
      } else {
        setFeedback({ isVisible: true, type: "error", title: "Subscription Failed", message: alerts.subscribeFailed });
      }
    } catch (error) {
      setFeedback({ isVisible: true, type: "error", title: "Something Went Wrong", message: alerts.subscribeError });
    }
  };

  const closeFeedback = () => {
    setFeedback({ isVisible: false, type: "error", title: "", message: "" });
  };

  return (
    <div className="about-mobile-container">
      <MessageModal
        isVisible={feedback.isVisible}
        title={feedback.title}
        message={feedback.message}
        type={feedback.type}
        onClose={closeFeedback}
      />
      <div className="about-image-container">
        <img src={logoLarge} alt="About" className="about-image" />
      </div>

      <div className="about-text">
        <p>{about.teamBio}</p>
      </div>

      <div className="newsletter-section">
        <h3>{about.newsletterTitle}</h3>
        <p>{about.newsletterDescription}</p>
        <div className="newsletter-form">
          <input
            className="input-newsletter-mobile"
            type="email"
            placeholder={about.newsletterPlaceholder}
            value={email}
            onChange={handleEmailChange}
          />
          <button className="button-newsletter-mobile" onClick={handleSubscribe} disabled={!email.trim()}>
            {about.newsletterButton}
          </button>
        </div>
        <p>
          {about.newsletterDisclaimer} <Link to="/privacy-policy">{about.newsletterDisclaimerLinkText}</Link>
        </p>{" "}
      </div>
    </div>
  );
};

export default About_Mobile;
